import { format, parseISO } from "date-fns";

export const baseUrl = import.meta.env.VITE_BASE_URL;

// Note: States are now fetched from the API via MasterContext
// Use useMasterData() hook to access states in components
// This function is kept for backward compatibility but now requires states as parameter
export function getStateIdByName(
  stateName: string,
  states?: Array<{ id: number | string; name: string }>
): number | string | undefined {
  if (!states) {
    console.warn(
      "getStateIdByName: states parameter is required. Use states from MasterContext via useMasterData() hook."
    );
    return undefined;
  }
  const state = states.find(
    (s) => s.name.toLowerCase() === stateName.toLowerCase()
  );
  return state?.id;
}

export function formatDateInS3(isoDateString: string): string {
  try {
    // Parse the ISO date string into a Date object
    const date = parseISO(isoDateString);

    // Format the date using date-fns
    const formattedDate = format(date, "d MMMM, yyyy"); // e.g., "11 December, 1980"

    return formattedDate;
  } catch (error) {
    console.error("Invalid date string:", error);
    throw new Error("Invalid date string");
  }
}

export const countryCodeList = [
  { code: "AF", label: "+93", flag: "AF" },
  { code: "AL", label: "+355", flag: "AL" },
  { code: "DZ", label: "+213", flag: "DZ" },
  { code: "AS", label: "+1-684", flag: "AS" },
  { code: "AD", label: "+376", flag: "AD" },
  { code: "AO", label: "+244", flag: "AO" },
  { code: "AI", label: "+1-264", flag: "AI" },
  { code: "AQ", label: "+672", flag: "AQ" },
  { code: "AG", label: "+1-268", flag: "AG" },
  { code: "AR", label: "+54", flag: "AR" },
  { code: "AM", label: "+374", flag: "AM" },
  { code: "AW", label: "+297", flag: "AW" },
  { code: "AU", label: "+61", flag: "AU" },
  { code: "AT", label: "+43", flag: "AT" },
  { code: "AZ", label: "+994", flag: "AZ" },
  { code: "BS", label: "+1-242", flag: "BS" },
  { code: "BH", label: "+973", flag: "BH" },
  { code: "BD", label: "+880", flag: "BD" },
  { code: "BB", label: "+1-246", flag: "BB" },
  { code: "BY", label: "+375", flag: "BY" },
  { code: "BE", label: "+32", flag: "BE" },
  { code: "BZ", label: "+501", flag: "BZ" },
  { code: "BJ", label: "+229", flag: "BJ" },
  { code: "BM", label: "+1-441", flag: "BM" },
  { code: "BT", label: "+975", flag: "BT" },
  { code: "BO", label: "+591", flag: "BO" },
  { code: "BA", label: "+387", flag: "BA" },
  { code: "BW", label: "+267", flag: "BW" },
  { code: "BR", label: "+55", flag: "BR" },
  { code: "IO", label: "+246", flag: "IO" },
  { code: "BN", label: "+673", flag: "BN" },
  { code: "BG", label: "+359", flag: "BG" },
  { code: "BF", label: "+226", flag: "BF" },
  { code: "BI", label: "+257", flag: "BI" },
  { code: "KH", label: "+855", flag: "KH" },
  { code: "CM", label: "+237", flag: "CM" },
  { code: "CA", label: "+1", flag: "CA" },
  { code: "CV", label: "+238", flag: "CV" },
  { code: "KY", label: "+1-345", flag: "KY" },
  { code: "CF", label: "+236", flag: "CF" },
  { code: "TD", label: "+235", flag: "TD" },
  { code: "CL", label: "+56", flag: "CL" },
  { code: "CN", label: "+86", flag: "CN" },
  { code: "CO", label: "+57", flag: "CO" },
  { code: "KM", label: "+269", flag: "KM" },
  { code: "CD", label: "+243", flag: "CD" },
  { code: "CG", label: "+242", flag: "CG" },
  { code: "CK", label: "+682", flag: "CK" },
  { code: "CR", label: "+506", flag: "CR" },
  { code: "HR", label: "+385", flag: "HR" },
  { code: "CU", label: "+53", flag: "CU" },
  { code: "CW", label: "+599", flag: "CW" },
  { code: "CY", label: "+357", flag: "CY" },
  { code: "CZ", label: "+420", flag: "CZ" },
  { code: "DK", label: "+45", flag: "DK" },
  { code: "DJ", label: "+253", flag: "DJ" },
  { code: "DM", label: "+1-767", flag: "DM" },
  { code: "DO", label: "+1-809", flag: "DO" },
  { code: "EC", label: "+593", flag: "EC" },
  { code: "EG", label: "+20", flag: "EG" },
  { code: "SV", label: "+503", flag: "SV" },
  { code: "GQ", label: "+240", flag: "GQ" },
  { code: "ER", label: "+291", flag: "ER" },
  { code: "EE", label: "+372", flag: "EE" },
  { code: "SZ", label: "+268", flag: "SZ" },
  { code: "ET", label: "+251", flag: "ET" },
  { code: "FK", label: "+500", flag: "FK" },
  { code: "FO", label: "+298", flag: "FO" },
  { code: "FJ", label: "+679", flag: "FJ" },
  { code: "FI", label: "+358", flag: "FI" },
  { code: "FR", label: "+33", flag: "FR" },
  { code: "GF", label: "+594", flag: "GF" },
  { code: "PF", label: "+689", flag: "PF" },
  { code: "GA", label: "+241", flag: "GA" },
  { code: "GM", label: "+220", flag: "GM" },
  { code: "GE", label: "+995", flag: "GE" },
  { code: "DE", label: "+49", flag: "DE" },
  { code: "GH", label: "+233", flag: "GH" },
  { code: "GI", label: "+350", flag: "GI" },
  { code: "GR", label: "+30", flag: "GR" },
  { code: "GL", label: "+299", flag: "GL" },
  { code: "GD", label: "+1-473", flag: "GD" },
  { code: "GU", label: "+1-671", flag: "GU" },
  { code: "GT", label: "+502", flag: "GT" },
  { code: "GN", label: "+224", flag: "GN" },
  { code: "GW", label: "+245", flag: "GW" },
  { code: "GY", label: "+592", flag: "GY" },
  { code: "HT", label: "+509", flag: "HT" },
  { code: "HN", label: "+504", flag: "HN" },
  { code: "HK", label: "+852", flag: "HK" },
  { code: "HU", label: "+36", flag: "HU" },
  { code: "IS", label: "+354", flag: "IS" },
  { code: "IN", label: "+91", flag: "IN" },
  { code: "ID", label: "+62", flag: "ID" },
  { code: "IR", label: "+98", flag: "IR" },
  { code: "IQ", label: "+964", flag: "IQ" },
  { code: "IE", label: "+353", flag: "IE" },
  { code: "IL", label: "+972", flag: "IL" },
  { code: "IT", label: "+39", flag: "IT" },
  { code: "JM", label: "+1-876", flag: "JM" },
  { code: "JP", label: "+81", flag: "JP" },
  { code: "JO", label: "+962", flag: "JO" },
  { code: "KZ", label: "+7", flag: "KZ" },
  { code: "KE", label: "+254", flag: "KE" },
  { code: "KI", label: "+686", flag: "KI" },
  { code: "KW", label: "+965", flag: "KW" },
  { code: "KG", label: "+996", flag: "KG" },
  { code: "LA", label: "+856", flag: "LA" },
  { code: "LV", label: "+371", flag: "LV" },
  { code: "LB", label: "+961", flag: "LB" },
  { code: "LS", label: "+266", flag: "LS" },
  { code: "LR", label: "+231", flag: "LR" },
  { code: "LY", label: "+218", flag: "LY" },
  { code: "LI", label: "+423", flag: "LI" },
  { code: "LT", label: "+370", flag: "LT" },
  { code: "LU", label: "+352", flag: "LU" },
  { code: "MO", label: "+853", flag: "MO" },
  { code: "MK", label: "+389", flag: "MK" },
  { code: "MG", label: "+261", flag: "MG" },
  { code: "MW", label: "+265", flag: "MW" },
  { code: "MY", label: "+60", flag: "MY" },
  { code: "MV", label: "+960", flag: "MV" },
  { code: "ML", label: "+223", flag: "ML" },
  { code: "MT", label: "+356", flag: "MT" },
  { code: "MH", label: "+692", flag: "MH" },
  { code: "MQ", label: "+596", flag: "MQ" },
  { code: "MR", label: "+222", flag: "MR" },
  { code: "MU", label: "+230", flag: "MU" },
  { code: "YT", label: "+262", flag: "YT" },
  { code: "MX", label: "+52", flag: "MX" },
  { code: "FM", label: "+691", flag: "FM" },
  { code: "MD", label: "+373", flag: "MD" },
  { code: "MC", label: "+377", flag: "MC" },
  { code: "MN", label: "+976", flag: "MN" },
  { code: "ME", label: "+382", flag: "ME" },
  { code: "MS", label: "+1-664", flag: "MS" },
  { code: "MA", label: "+212", flag: "MA" },
  { code: "MZ", label: "+258", flag: "MZ" },
  { code: "MM", label: "+95", flag: "MM" },
  { code: "NA", label: "+264", flag: "NA" },
  { code: "NR", label: "+674", flag: "NR" },
  { code: "NP", label: "+977", flag: "NP" },
  { code: "NL", label: "+31", flag: "NL" },
  { code: "NC", label: "+687", flag: "NC" },
  { code: "NZ", label: "+64", flag: "NZ" },
  { code: "NI", label: "+505", flag: "NI" },
  { code: "NE", label: "+227", flag: "NE" },
  { code: "NG", label: "+234", flag: "NG" },
  { code: "NU", label: "+683", flag: "NU" },
  { code: "KP", label: "+850", flag: "KP" },
  { code: "NO", label: "+47", flag: "NO" },
  { code: "OM", label: "+968", flag: "OM" },
  { code: "PK", label: "+92", flag: "PK" },
  { code: "PW", label: "+680", flag: "PW" },
  { code: "PA", label: "+507", flag: "PA" },
  { code: "PG", label: "+675", flag: "PG" },
  { code: "PY", label: "+595", flag: "PY" },
  { code: "PE", label: "+51", flag: "PE" },
  { code: "PH", label: "+63", flag: "PH" },
  { code: "PL", label: "+48", flag: "PL" },
  { code: "PT", label: "+351", flag: "PT" },
  { code: "PR", label: "+1-787", flag: "PR" },
  { code: "QA", label: "+974", flag: "QA" },
  { code: "RO", label: "+40", flag: "RO" },
  { code: "RU", label: "+7", flag: "RU" },
  { code: "RW", label: "+250", flag: "RW" },
  { code: "RE", label: "+262", flag: "RE" },
  { code: "BL", label: "+590", flag: "BL" },
  { code: "SH", label: "+290", flag: "SH" },
  { code: "KN", label: "+1-869", flag: "KN" },
  { code: "LC", label: "+1-758", flag: "LC" },
  { code: "MF", label: "+590", flag: "MF" },
  { code: "PM", label: "+508", flag: "PM" },
  { code: "VC", label: "+1-784", flag: "VC" },
  { code: "WS", label: "+685", flag: "WS" },
  { code: "SM", label: "+378", flag: "SM" },
  { code: "ST", label: "+239", flag: "ST" },
  { code: "SA", label: "+966", flag: "SA" },
  { code: "SN", label: "+221", flag: "SN" },
  { code: "RS", label: "+381", flag: "RS" },
  { code: "SC", label: "+248", flag: "SC" },
  { code: "SL", label: "+232", flag: "SL" },
  { code: "SG", label: "+65", flag: "SG" },
  { code: "SX", label: "+1-721", flag: "SX" },
  { code: "SK", label: "+421", flag: "SK" },
  { code: "SI", label: "+386", flag: "SI" },
  { code: "SB", label: "+677", flag: "SB" },
  { code: "SO", label: "+252", flag: "SO" },
  { code: "ZA", label: "+27", flag: "ZA" },
  { code: "GS", label: "+500", flag: "GS" },
  { code: "KR", label: "+82", flag: "KR" },
  { code: "ES", label: "+34", flag: "ES" },
  { code: "LK", label: "+94", flag: "LK" },
  { code: "SD", label: "+249", flag: "SD" },
  { code: "SR", label: "+597", flag: "SR" },
  { code: "SS", label: "+211", flag: "SS" },
  { code: "SY", label: "+963", flag: "SY" },
  { code: "TW", label: "+886", flag: "TW" },
  { code: "TJ", label: "+992", flag: "TJ" },
  { code: "TZ", label: "+255", flag: "TZ" },
  { code: "TH", label: "+66", flag: "TH" },
  { code: "TG", label: "+228", flag: "TG" },
  { code: "TK", label: "+690", flag: "TK" },
  { code: "TO", label: "+676", flag: "TO" },
  { code: "TT", label: "+1-868", flag: "TT" },
  { code: "TN", label: "+216", flag: "TN" },
  { code: "TR", label: "+90", flag: "TR" },
  { code: "TM", label: "+993", flag: "TM" },
  { code: "TC", label: "+1-649", flag: "TC" },
  { code: "TV", label: "+688", flag: "TV" },
  { code: "UG", label: "+256", flag: "UG" },
  { code: "UA", label: "+380", flag: "UA" },
  { code: "AE", label: "+971", flag: "AE" },
  { code: "GB", label: "+44", flag: "GB" },
  { code: "US", label: "+1", flag: "US" },
  { code: "UY", label: "+598", flag: "UY" },
  { code: "UZ", label: "+998", flag: "UZ" },
  { code: "VU", label: "+678", flag: "VU" },
  { code: "VE", label: "+58", flag: "VE" },
  { code: "VN", label: "+84", flag: "VN" },
  { code: "WF", label: "+681", flag: "WF" },
  { code: "EH", label: "+212", flag: "EH" },
  { code: "YE", label: "+967", flag: "YE" },
  { code: "ZM", label: "+260", flag: "ZM" },
  { code: "ZW", label: "+263", flag: "ZW" },
];
